<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="原告名称" >
            <template slot-scope="scope">
              {{ scope.row.accuser_name }}
            </template>
        </el-table-column>
        <el-table-column label="案号">
            <template slot-scope="scope">
              {{ scope.row.case_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="案由名称">
            <template slot-scope="scope">
              {{ scope.row.cause_of_action_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="法院名称（执行者）">
            <template slot-scope="scope">
              {{ scope.row.court_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="被告名称">
            <template slot-scope="scope">
              {{ scope.row.defendant_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="案件类型">
            <template slot-scope="scope">
              {{ scope.row.case_type_name || '-' }}
            </template>
        </el-table-column>
        
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'refereeDocumentList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '裁判文书',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>